import { Column } from '@tanstack/react-table';
import { isEmpty } from 'lodash';
import * as React from 'react';

import { FacetedFilter } from '../filter';

interface DataTableFacetedFilterProps<TData, TValue> {
  column?: Column<TData, TValue>;
  title: string;
  searchPlaceholder?: string;
  loading?: boolean;
  loadingText?: string;
  multiple?: boolean;
  options: {
    label: string;
    value: any;
    icon?: React.ComponentType<{ className?: string }>;
  }[];
  className?: string;
}

export function DataTableFacetedFilter<TData, TValue>({
  column,
  title,
  searchPlaceholder,
  loading = false,
  loadingText = '加载中...',
  multiple,
  options,
  className,
}: DataTableFacetedFilterProps<TData, TValue>) {
  const facets = column?.getFacetedUniqueValues();
  // 保持原始值类型（string 或 number），避免被强制为 string 导致类型不匹配
  const filterValue = column?.getFilterValue();

  const handleReset = () => {
    column?.setFilterValue(undefined);
  };

  const handleChange = (value: any) => {
    column?.setFilterValue(multiple && Array.isArray(value) && isEmpty(value) ? undefined : value);
  };

  return (
    <FacetedFilter
      title={title}
      options={options}
      facets={facets}
      onChange={handleChange}
      onReset={handleReset}
      searchPlaceholder={searchPlaceholder}
      loading={loading}
      loadingText={loadingText}
      className={className}
      value={filterValue}
      multiple={multiple}
    />
  );
}
